export type DocumentEditSiteWarningProps = {
  siteId?: string;
  newSiteIds: string[];
};
export function DocumentEditSiteWarning({
  siteId,
  newSiteIds,
}: DocumentEditSiteWarningProps) {
  let text = undefined;

  if (siteId) {
    if (newSiteIds.length === 0) {
      text =
        'Removing all sites will move this document to the "Global Documents" page.';
    } else if (!newSiteIds.includes(siteId)) {
      text = 'These changes remove this document from the current site.';
    }
  } else if (newSiteIds.length > 0) {
    text =
      'Assigning sites will remove this document from the "Global Documents" page.';
  }

  if (text) {
    return (
      <div className="mt-2 text-xs text-orange-600">
        <span className="font-semibold">Warning:</span> {text}
      </div>
    );
  }

  return null;
}
